import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';

import {PaymentFormTemplate, OptileForm} from '../../organisms';
import Spinner from '../../atoms/Spinner';
import * as optileActions from '../../../actions/optile';
import {
    getTranslations, getGenericError, getLanguageCode, getAvailableLanguageCodes
} from '../../../utils/selectors';
import localiseUrl from '../../../utils/localiseUrl';
import {redirectTo} from '../../../utils/helpers';
import {isOptileLoaded, getPaymentMethodCards} from '../../../selectors/optile';

const Optile = ({
    match,
    translations,
    languageCode,
    availableLanguageCodes,
    loaded,
    redirectUrl,
    dataInit,
    paymentMethodsCards,
    cancellationUrl,
    isSubmitting,
    errorMessage,
    dispatch
}) => {
    const {params: {sessionId}} = match;

    useEffect(() => {
        dispatch(optileActions.init(sessionId, languageCode));
    }, [dispatch, languageCode, sessionId]);

    const handleSubmit = (values = {}) => {
        dispatch(optileActions.pay(values));
    };

    if (redirectUrl) {
        redirectTo(redirectUrl, {method: 'GET'});
        return (
            <div className="optile-container">
                <Spinner />
            </div>
        );
    }

    return (
        <div className="optile-container">
            {!loaded && <Spinner />}

            <PaymentFormTemplate
                translations={translations}
                cancellationUrl={cancellationUrl}
                paymentMethods={paymentMethodsCards}
                title={translations.formHeader.payMethod}
            >
                <OptileForm
                    translations={translations}
                    languageCode={languageCode}
                    availableLanguageCodes={availableLanguageCodes}
                    initialData={dataInit}
                    onSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    errorMessage={errorMessage}
                />
            </PaymentFormTemplate>
        </div>
    );
};

Optile.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            sessionId: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    translations: PropTypes.shape().isRequired,
    languageCode: PropTypes.string.isRequired,
    redirectUrl: PropTypes.string,
    cancellationUrl: PropTypes.string,
    dataInit: PropTypes.shape({}).isRequired,
    loaded: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool,
    errorMessage: PropTypes.string
};

Optile.defaultProps = {
    redirectUrl: '',
    cancellationUrl: '',
    isSubmitting: false,
    errorMessage: ''
};

const mapStateToProps = state => {
    const languageCode = getLanguageCode(state);
    const availableLanguageCodes = getAvailableLanguageCodes(state);
    const {cancelUrl, failureUrl} = state.optileData.dataInit;

    return {
        languageCode,
        availableLanguageCodes,
        translations: getTranslations(state),
        loaded: isOptileLoaded(state),
        redirectUrl: localiseUrl(failureUrl, languageCode, availableLanguageCodes),
        cancellationUrl: localiseUrl(cancelUrl, languageCode, availableLanguageCodes),
        paymentMethodsCards: getPaymentMethodCards(state),
        dataInit: state.optileData.dataInit,
        isSubmitting: state.optileData.loadingForm,
        genericError: getGenericError(state),
        errorMessage: state.optileData.error
    };
};

export const ConnectedOptile = connect(mapStateToProps)(Optile);

export default withRouter(ConnectedOptile);
